import dayjs, { Dayjs } from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import utc from "dayjs/plugin/utc";

dayjs.extend(isBetween);
dayjs.extend(utc);

type WeekdayName =
  | "domingo"
  | "segunda-feira"
  | "terça-feira"
  | "quarta-feira"
  | "quinta-feira"
  | "sexta-feira"
  | "sábado";

interface WeekdayNameMap {
  [key: string]: WeekdayName;
}

export const weekdayNameMap: WeekdayNameMap = {
  1: "segunda-feira",
  2: "terça-feira",
  3: "quarta-feira",
  4: "quinta-feira",
  5: "sexta-feira",
  6: "sábado",
  0: "domingo",
};

export function getWeekdayName(key: keyof typeof weekdayNameMap): WeekdayName {
  return weekdayNameMap[key];
}

const setTime = (moment: dayjs.Dayjs, time: string) => {
  const timeRegexp = /\d\d:\d\d:\d\d/;

  if (!timeRegexp.test(time)) {
    throw Error("time must have the format \\d\\d:\\d\\d:\\d\\d");
  }

  return moment
    .hour(parseInt(time.split(":")[0]))
    .minute(parseInt(time.split(":")[1]))
    .second(parseInt(time.split(":")[2]));
};

const getWeekdayDifferenceInDays = (minuend: number, subtrahend: number) => {
  if (minuend < 0 || minuend > 6 || subtrahend < 0 || subtrahend > 6) {
    throw Error("weekdays be between 0 and 6");
  }

  return (minuend - subtrahend + 7) % 7;
};

export const getStartMoment = (startWeekday: number, startTime: string) => {
  const now = dayjs.utc();
  const startMoment = setTime(
    now.subtract(getWeekdayDifferenceInDays(now.day(), startWeekday), "day"),
    startTime,
  );

  return startMoment;
};

export const getEndMoment = (
  startMoment: Dayjs,
  startWeekday: number,
  endWeekday: number,
  endTime: string,
) => {
  const endMoment = setTime(
    startMoment.add(
      getWeekdayDifferenceInDays(endWeekday, startWeekday),
      "day",
    ),
    endTime,
  );

  return endMoment;
};

export const isNowBetweenInterval = (
  startWeekday: number,
  startTime: string,
  endWeekday: number,
  endTime: string,
) => {
  const startMoment = getStartMoment(startWeekday, startTime);
  const endMoment = getEndMoment(
    startMoment,
    startWeekday,
    endWeekday,
    endTime,
  );
  const now = dayjs.utc();

  return now.isBetween(startMoment, endMoment);
};
